<template>
    <div>
        <modal class="biz-pay-atm-detail" :display="modalStatus.bizVirtualAccount" @modalStatus="closeModal" >
            <h1>付款明細</h1>
            <div class="alarm-info">
                <img src="@/assets/img/icon/alarm_msg_error.svg" alt="">
                請您在 30 分鐘內完成匯款，尚未完成則取消委託新增。
            </div>
            <div class="pay-atm-detail-wrap">
                <div class="content">
                    <div class="list">
                        <span class="title">訂單編號</span>
                        <span class="info">：{{virtualAccountDetail.referenceSeq}}</span>
                    </div>
                    <div class="list">
                        <span class="title">付款方式</span>
                        <span class="info">：匯款轉帳</span>
                    </div>
                    <div class="list">
                        <span class="title">匯款項目</span>
                        <span class="info">：委託獎金</span>
                    </div>
                    <div class="list">
                        <span class="title">銀行名稱</span>
                        <span class="info">：{{virtualAccountDetail.bankName}}{{virtualAccountDetail.bankBranchName}}</span>
                    </div>
                    <div class="list">
                        <span class="title">銀行代號</span>
                        <span class="info">：{{virtualAccountDetail.bankCode}}</span>
                    </div>
                    <div class="list">
                        <span class="title">匯款帳號</span>
                        <span class="info">：{{virtualAccountDetail.bankAccount}}</span>
                    </div>
                    <div class="list">
                        <span class="title">金額幣別</span>
                        <span class="info">：{{virtualAccountDetail.currencyType}}</span>
                    </div>
                    <div class="list">
                        <span class="title">匯款金額</span>
                        <span class="info">：{{toCurrency(virtualAccountDetail.payableAmount)}}</span>
                    </div>
                    <div class="list">
                        <span class="title">建立時間</span>
                        <span class="info">：{{getFormatDate(virtualAccountDetail.createTime)}}</span>
                    </div>
                    <div class="list">
                        <span class="title">繳款期限</span>
                        <span class="info warm">：{{getFormatDate(virtualAccountDetail.expireTime)}}</span>
                    </div>
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button confirm" @click="closeModal()">確認</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import { mapGetters } from 'vuex'

import { 
    apiBizGetVirtualAccount
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            componentKey: 0,
            virtualAccountDetail: {
                bankName: null,
                bankBranchName: null,
                bankCode: null,
                bankAccount: null,
                currencyType: null,
                payableAmount: 0,
                createTime: null,
                expireTime: null,
            },
        }
    },
    props:{
        task: null
    },
    watch: {
        task: {
            handler: function (val) {
                // console.log(val)
                if(val){    
                    this.getVirtualAccountDetail(val)
                }
            },
            immediate: true
        }
    },
    // mounted() {
    //     this.$analytics.logEvent("付款明細");
    // },
    methods: {
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'bizVirtualAccount'})
            this.componentKey += 1
        },
        getVirtualAccountDetail: function (taskId) {
            let data = taskId

            apiBizGetVirtualAccount(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.virtualAccountDetail = res.data.result.bindAccountDto
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            formatDate[5] = (Array(2).join(0)+date.getSeconds()).slice(-2);
            //月及天兩位數
            formatDate[6] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[7] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            // if(formatDate[3] - 8 < 0){
            //     formatDate[3] = 24+(formatDate[3]-8);
            //     formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            // }else{
            //     formatDate[3] = formatDate[3]-8;
            //     formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            // }
            return formatDate[0]+'-'+formatDate[6]+'-'+formatDate[7]+' '+formatDate[3]+':'+formatDate[4]+':'+formatDate[5];
        },
        // toCurrency: function (num){
        //     if(num){
        //         var parts = num.toString().split('.');
        //         // console.log(parts);
        //         parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //         return parts.join('.');
        //     }
        // },
    },
    computed: {
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
    }
}
</script>
<style lang="scss"  >
    #modal.biz-pay-atm-detail{
        .modal-content{
            width: 448px;
            padding: 0 !important;
            .detail{
                align-items: flex-start;
                >h1{
                    font-size: 24px;
                    margin: 32px auto 20px;
                }
                .alarm-info{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    color: #fc7171;
                    height: 45px;
                    background-color: rgba(252, 113, 113, 0.1);
                    img{
                        width: 16px;
                        margin-right: 8px;
                        margin-left: 32px;
                    }
                }
                .pay-atm-detail-wrap{
                    padding: 32px;
                    .content{
                        margin-bottom: 20px;
                        .list{
                            display: flex;
                            margin-bottom: 16px;
                            .title{
                                display: block;
                                width: 56px;
                            }
                        }
                        .warm{
                            color: #fc7171;
                        }
                    }
                }
            }
            
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 384px;
                    height: 44px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/modals/virtualAccount.vue